// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"666b3b96","611":"39b13cf0","752":"6f3e1a8f"}[chunkId] + ".chunk.js";
};